import React from 'react';
import { Button, CircularProgress, Divider, Modal, Box } from '@mui/material';
import PrimaryButton from './PrimaryButton';
import SecondaryButton from './SecondaryButton';
import { useTranslation } from 'react-i18next';

const ModalBasic = ({
  open,
  setOpen,
  width = 600,
  title = 'Modal',
  onSave,
  styleProp,
  isView = false,
  isDrawer = false,
  titleSave = 'Save',
  titleCancel = 'Cancel',
  willUnMount,
  type = 'button',
  isFooter = true,
  isHeader = true,
  loading = false,
  children,
  mode = 'edit',
  ...rest
}) => {
  const { t } = useTranslation(['workflow']);
  const handleClose = () => {
    setOpen(false);
  };

  const modalBlockStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: width,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '4px',
    maxHeight: '90vh',
    overflowY: 'auto',
    ...styleProp,
    ...(isDrawer && {
      height: '100%',
      right: 0,
      left: 'auto',
      transform: 'none',
      borderRadius: 0,
    }),
  };

  const modalHeaderStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 24px',
  };

  const modalTitleStyle = {
    fontSize: '16px',
    fontWeight: 500,
  };

  const modalChildrenStyle = {
    padding: '10px',
    maxHeight: isFooter ? 'calc(90vh - 130px)' : 'calc(90vh - 65px)',
    overflowY: 'auto',
  };

  const modalFooterStyle = {
    display: 'flex',
    justifyContent: isView ? 'center' : 'flex-end',
    padding: '16px 24px',
    gap: '8px',
  };

  return (
    <Modal open={open} onClose={handleClose} {...rest}>
      <Box sx={modalBlockStyle}>
        {isHeader && (
          <>
            <Box sx={modalHeaderStyle}>
              <Box sx={modalTitleStyle}>{title}</Box>
              <Button
                onClick={handleClose}
                sx={{ minWidth: 'initial' }}
                id="snr-ai-modal-closeButton"
              >
                ✕
              </Button>
            </Box>
            <Divider />
          </>
        )}

        <Box sx={modalChildrenStyle}>{children}</Box>

        {isFooter && mode !== 'view' && (
          <>
            <Divider />
            <Box sx={modalFooterStyle}>
              {!isView && (
                <PrimaryButton
                  onClick={onSave}
                  disabled={loading}
                  loading={loading}
                  id="snr-ai-modal-saveButton"
                  text={titleSave}
                />
              )}
              <SecondaryButton
                onClick={handleClose}
                type="button"
                disabled={loading}
                id="snr-ai-modal-cancelButton"
                text={isView ? t('Done') : t(titleCancel)}
              />
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default ModalBasic;
